import { render } from "./SponsorDivComponent.vue?vue&type=template&id=6480001c&scoped=true"
import script from "./SponsorDivComponent.vue?vue&type=script&lang=js"
export * from "./SponsorDivComponent.vue?vue&type=script&lang=js"

import "./SponsorDivComponent.vue?vue&type=style&index=0&id=6480001c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6480001c"]])

export default __exports__